import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useUsersByGroup } from './useUsersByGroup';

export const useUsersByGroupModal = (onClose, groupId, groupName) => {
    const { t } = useTranslation();
    const {
        users,
        loading,
        saving,
        error,
        modalRef,
        usersToRemove,
        handleRemoveUser,
        handleSave,
        fetchUsers,
    } = useUsersByGroup(onClose, groupId);

    const [showAddUsers, setShowAddUsers] = useState(false);
    const [showMainModal, setShowMainModal] = useState(true);

    const handleAddUsersClick = () => {
        setShowMainModal(false);
        setShowAddUsers(true);
    };

    const handleAddUsersClose = async (result) => {
        setShowAddUsers(false);
        
        if (result === 'closeAll') {
            onClose(true);
        }
    };

    const handleMainClose = () => {
        onClose(true);
    };

    return {
        // Modal states
        showAddUsers,
        showMainModal,
        
        // Data states
        users,
        loading,
        saving,
        error,
        modalRef,
        usersToRemove,
        
        // Handlers
        handleAddUsersClick,
        handleAddUsersClose,
        handleMainClose,
        handleRemoveUser,
        handleSave,
        
        // Utils
        t
    };
}; 